import styled from 'styled-components'

const LazyImage = styled.img.attrs({
  loading: 'lazy'
})`
  max-width: 100%;
  height: auto;
  object-fit: cover;
`

export default LazyImage
